"use strict";

// see https://www.raymondcamden.com/2023/03/14/progressively-enhancing-a-table-with-a-web-component

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// load font via webpack asset/resource
// require("src/tokens/index.css");

const CHILD_ROW_CLASS = "child-row";


function _renderDetailRow (label, value) {

    let tr = document.createElement("tr");
    let tdLabel = document.createElement("td");
    tdLabel.innerText = label;
    let tdLValue = document.createElement("td");
    tdLValue.innerText = value;
    tr.appendChild(tdLabel);
    tr.appendChild(tdLValue);
    return tr;
}

function _renderAddress (table, label, address) {
    const titleRow = document.createElement("tr");
    const titleCell = document.createElement("td");
    titleCell.className = "title";
    titleCell.innerText = label;
    titleRow.appendChild(titleCell);
    table.appendChild(titleRow);
    if (address.operational_name) {
        table.appendChild(_renderDetailRow("Operational name", address.operational_name));
    }
    if (address.legal_name) {
        table.appendChild(_renderDetailRow("Legal name", address.legal_name));
    }
    if (address.city) {
        table.appendChild(_renderDetailRow("City", address.city));
    }
    if (address.cps) {
        table.appendChild(_renderDetailRow("CPS", address.cps));
    }
    if (address.pob_number) {
        table.appendChild(_renderDetailRow("POB number", address.pob_number));
    }
    if (address.street_address_1) {
        table.appendChild(_renderDetailRow("Street address 1", address.street_address_1));
    }
    if (address.street_address_2) {
        table.appendChild(_renderDetailRow("Street address 2", address.street_address_2));
    }
    if (address.street_address_3) {
        table.appendChild(_renderDetailRow("Street address 3", address.street_address_3));
    }
}

function _renderDetailsTable (details) {

    const table = document.createElement("table");

    // if (details.legal_name) {
    //     table.appendChild(_renderDetailRow("Legal name", details.legal_name));
    // }
    if (details.branch_address) {
        _renderAddress(table, "Branch address", details.branch_address);
    }
    if (details.operational_address) {
        details.operational_address.operational_name = details.institution_name;
        _renderAddress(table, "Operational name and address", details.operational_address);
    }
    if (details.registered_address) {
        details.registered_address.legal_name = details.legal_name;
        _renderAddress(table, "Legal name and address", details.registered_address);
    }

    return table;
}

class Table extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.table = this.root.querySelector("table");
        this.defaultThead;
        this.table.addEventListener("click", this.toggleChildRows.bind(this));
    }



    toggleChildRows (event) {
        const target = event.target;
        if (target.hasAttribute("data-details")) {
            event.preventDefault();

            const details = JSON.parse(target.getAttribute("data-details"));
            const row = target.closest("tr");

            if (row.nextElementSibling && row.nextElementSibling.classList.contains(CHILD_ROW_CLASS)) {
                row.parentNode.removeChild(row.nextElementSibling);
            } else {
                const childRow = document.createElement("tr");
                childRow.className = CHILD_ROW_CLASS;
                const childCell = document.createElement("td");
                childCell.colSpan = row.cells.length;

                childCell.appendChild(_renderDetailsTable(details));
                childRow.appendChild(childCell);
                row.parentNode.insertBefore(childRow, row.nextElementSibling);
            }
        }
    }
    connectedCallback() {

        const tableTemplate = document.createElement("template");
        tableTemplate.innerHTML = this.innerHTML;
        if (this.innerHTML) {
            this.table.innerHTML = this.innerHTML;
        }
        this.innerHTML = "";
        this.data = [];
        this.tbody = this.table.querySelector('tbody');
        this.thead = this.table.querySelector('thead');
        if (!this.defaultThead && this.thead) {
            this.defaultThead = this.thead;

        }
        if (!this.thead && this.defaultThead) {
            this.thead = this.table.createTHead();
            this.table.replaceChild(this.defaultThead, this.thead)
        }

        if (this.tbody) {
            let rows = this.tbody.querySelectorAll('tr');
            rows.forEach(r => {
                let datum = [];
                let tds = r.querySelectorAll('td');
                tds.forEach((r,i) => {
                    datum[i] = r;
                });
                this.data.push(datum);
            });
            this.style.display = "";
        } else {
            this.style.display = "none";
        }

    }
}

customElements.define('swiftref-table', Table);

module.exports = Table;
